import { render, staticRenderFns } from "./6_about_us.vue?vue&type=template&id=156e8d5d&scoped=true&"
import script from "./6_about_us.vue?vue&type=script&lang=js&"
export * from "./6_about_us.vue?vue&type=script&lang=js&"
import style0 from "./6_about_us.vue?vue&type=style&index=0&id=156e8d5d&lang=scss&scoped=true&"
import style1 from "./6_about_us.vue?vue&type=style&index=1&id=156e8d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e8d5d",
  null
  
)

export default component.exports